import React from 'react';
import { Field } from 'react-final-form';
import { required } from '@/components/common/Forms/Validators';
import Icon from '@/components/ui/Icon';
import TCITooltip from '@/components/ui/Tooltip/TCITooltip';

interface TextFieldProps {
  isHorizontal?: boolean;
  label: string;
  labelWidth?: number;
  name: string;
  id: string;
}

const TextField = ({ isHorizontal = true, label, labelWidth = 140, name, id }: TextFieldProps) => {
  const labelMargin = 8;
  const labelWidthMinusMargin = labelWidth - labelMargin;

  return (
    <Field
      name={name}
      validate={required}
    >
      {({ input, meta }) => (
        <div className="tw-flex tw-flex-col tw-py-1 tw-mb-1">
          <div className={`tw-flex  ${isHorizontal ? 'tw-items-center' : 'tw-flex-col'}`}>
            <label
              className="tw-font-bold tw-overflow-visible"
              htmlFor={id}
              style={{
                marginRight: `${labelMargin}px`,
                minWidth: `${labelWidthMinusMargin}px`,
                width: `${labelWidthMinusMargin}px`,
              }}
            >
              {label}
            </label>

            <input
              className={`tw-w-[230px] tw-h-[26px] tw-py-0 tw-px-1 tw-overflow-hidden
                          tw-relative tw-border tw-border-solid tw-rounded-md tw-border-[#ccc]
                          ${meta.error && meta.submitFailed ? 'tw-border-red' : 'tw-border-[#ccc]'}`}
              id={id}
              {...input}
            />
          </div>

          {meta.error && meta.touched && (
            <div
              className="tw-text-red tw-mt-1"
              style={{ marginLeft: `${labelWidth}px` }}
            >
              {meta.error}
            </div>
          )}
        </div>
      )}
    </Field>
  );
};

interface CheckboxFieldProps {
  label: string;
  name: string;
  id: string;
  tooltipContent?: string;
}

const CheckboxField = ({ label, name, id, tooltipContent }: CheckboxFieldProps) => (
  <div className="tw-flex tw-items-center tw-my-4">
    <Field
      component="input"
      id={id}
      name={name}
      type="checkbox"
    />

    <div className="tw-flex tw-items-center tw-ml-1 tw-font-bold tw-overflow-visible">
      <label htmlFor={id}>{label}</label>
      {tooltipContent && (
        <TCITooltip side="right">
          <TCITooltip.Trigger asChild>
            <div className="tw-flex tw-items-center tw-cursor-pointer">
              <Icon
                className="tw-inline tw-ml-2"
                icon="InfoAlternate"
                size={14}
              />
            </div>
          </TCITooltip.Trigger>
          <TCITooltip.Content>
            {tooltipContent}
          </TCITooltip.Content>
        </TCITooltip>
      )}
    </div>
  </div>
);

const Fields = {
  CheckboxField,
  TextField,
};

export default Fields;
